module.exports = __webpack_public_path__ + "img/1.8556e0d1.jpg";